import type { SVGProps } from "react";
export interface MugHotIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MugHotIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MugHotIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.664.926a1.125 1.125 0 0 1 .78 2.107l-.033.014c.008-.004-.006 0-.02.037a.17.17 0 0 0 0 .121l.3.737.079.219c.308 1.03-.101 2.204-1.074 2.75l-.217.107-.035.015-.107.041a1.125 1.125 0 0 1-.78-2.108l.033-.014.02-.036a.2.2 0 0 0 .01-.061l-.011-.062-.3-.736c-.47-1.15.01-2.559 1.212-3.077l.034-.013.109-.04Zm4.5 0a1.125 1.125 0 0 1 .78 2.107l-.033.014c.008-.004-.006 0-.02.037a.17.17 0 0 0 0 .121l.3.737c.441 1.078.047 2.384-.995 2.97l-.217.106-.035.015-.107.041a1.125 1.125 0 0 1-.78-2.108l.033-.014.02-.036a.2.2 0 0 0 .01-.061l-.011-.062-.3-.736c-.47-1.15.01-2.559 1.213-3.077l.033-.013.109-.04Zm4.5 0a1.125 1.125 0 0 1 .78 2.107l-.033.014c.008-.004-.006 0-.02.037a.17.17 0 0 0 0 .121l.3.737.079.219c.308 1.03-.101 2.204-1.074 2.75l-.217.107-.035.015-.107.041a1.125 1.125 0 0 1-.78-2.108l.033-.014.02-.036a.2.2 0 0 0 .01-.061l-.011-.062-.3-.736c-.47-1.15.01-2.559 1.213-3.077l.033-.013.109-.04Zm6.211 11.744a.792.792 0 0 0-.888-.786l.001.001-.864.109.002.005v2.639l1.14-.797.135-.109c.3-.269.473-.654.474-1.062m2.25 0a3.68 3.68 0 0 1-1.57 3.014l-2.59 1.812a7.126 7.126 0 0 1-6.964 5.629H8A7.125 7.125 0 0 1 .875 16v-4A3.125 3.125 0 0 1 4 8.874h12c.887 0 1.686.37 2.254.962l1.452-.184h.001l.337-.024a3.04 3.04 0 0 1 3.08 3.041Zm-20 3.33A4.875 4.875 0 0 0 8 20.875h4A4.875 4.875 0 0 0 16.876 16v-4a.876.876 0 0 0-.876-.874H4a.875.875 0 0 0-.874.873v4Z"
      />
    </svg>
  );
}
